
const initialState = {
}

export default function PscChainReducer(state = initialState, action) {
  switch (action.type) {
    case 'INITIALIZE_VALUES_PSC_CHAIN': {
      return Object.assign({}, {}, { ...action.payload })
    }
    default:
      return state
  }
}
